import CustomButton from 'components/Buttons/CustomButton'
import { useEffect, useState } from 'react'
import { AlertCircle } from 'react-feather'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Modal, ModalBody } from 'reactstrap'
import { URL_UTANG } from 'utils/pathUrl'
import { getPendingPayable, getPendingPayablePersonal } from './payableAction'
import {
  useApprovePendingMutation,
  useApprovePendingPersonalMutation,
  useRejectPendingMutation,
  useRejectPendingPersonalMutation,
} from './payableNotesApiSlice'
import {
  setBannerMsg,
  toggleBanner,
  toggleModalConfirm,
} from './payableNotesSlice'

const ModalConfirm = ({ row, isDelete }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [errMsg, setErrMsg] = useState('')
  const { isOpenModalConfirm } = useSelector((s) => s.payableNotes)
  const [rejectPayableCompany, resultCompany] = useRejectPendingMutation()
  const [rejectPayablePersonal, resultPersonal] = useRejectPendingPersonalMutation()
  const [approvePayableCompany, resultApproveCompany] = useApprovePendingMutation()
  const [approvePayablePersonal, resultApprovePersonal] = useApprovePendingPersonalMutation()
  const { type } = useSelector((s) => s.payableNotes)

  const rejectPayable = type === 'personal' ? rejectPayablePersonal : rejectPayableCompany
  const approvePayable = type === 'personal' ? approvePayablePersonal : approvePayableCompany
  const resultApprove = type === 'personal' ? resultApprovePersonal : resultApproveCompany
  const result = type === 'personal' ? resultPersonal : resultCompany

  const handleSubmit = async () => {
    try {
      const body = {
        id: row?.id,
      }
      const resp = (await isDelete)
        ? rejectPayable(body).unwrap()
        : approvePayable(body).unwrap()
      if (!resp?.data?.error) {
        dispatch(toggleModalConfirm())
        navigate(URL_UTANG)
        dispatch(
          isDelete
            ? setBannerMsg('Catatan utang berhasil ditolak.')
            : setBannerMsg('Utang berhasil dikonfirmasi dan dicatat.'),
        )
        dispatch(toggleBanner())
        if (type === 'personal') {
          dispatch(getPendingPayablePersonal())
        } else {
          dispatch(getPendingPayable())
        }
      } else {
        throw resp
      }
    } catch (error) {
      setErrMsg(error?.data?.message ?? error?.message)
    }
  }

  useEffect(() => {
    if (!isOpenModalConfirm) {
      setErrMsg('')
    }
  }, [isOpenModalConfirm])

  return (
    <Modal
      centered
      toggle={() => dispatch(toggleModalConfirm())}
      isOpen={isOpenModalConfirm}
    >
      <ModalBody>
        <h6 className="fw-600">
          {isDelete ? 'Tolak' : 'Terima'} catatan utang
        </h6>
        <span>
          {isDelete
            ? 'Utang akan dihapus dari catatan Anda. Lanjutkan?'
            : 'Utang ini akan masuk ke catatan Anda. Lanjutkan?'}
        </span>
        {errMsg && (
          <small className="text-danger">
            <AlertCircle size={15} /> {errMsg}
          </small>
        )}
        <div className="d-flex gap-3 mt-4">
          <CustomButton
            onClick={() => dispatch(toggleModalConfirm())}
            block
            outline
            color="secondary"
            disabled={result?.isLoading || resultApprove?.isLoading}
          >
            Batal
          </CustomButton>

          <CustomButton
            onClick={handleSubmit}
            block
            color="primary"
            disabled={result?.isLoading || resultApprove?.isLoading}
          >
            {isDelete ? 'Tolak' : 'Terima'}
          </CustomButton>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default ModalConfirm
